import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import MyRewards from './reusable-components/myRewards';
import UsePoints from './reusable-components/usePoints';

function RewardsTab() {
    return (
        <div>
            <Tabs fill
                defaultActiveKey="home"
                transition={false}
                id="noanim-tab-example"
                className="mb-3"
            >
                <Tab eventKey="home" title="MY REWARDS" style={{
                    font: 'Sintony',
                    fontSize: '14px',
                    lineHeight: '18.24px',
                    color: '#475666',
                    textAlign: 'center',
                    fontWeight: '700',
                    marginBottom: '40px',
                    marginTop: '40px',
                    marginLeft: '10px'
                }}>
                    <MyRewards />
                </Tab>
                <Tab eventKey="profile" title="USE POINTS" style={{
                    font: 'Sintony',
                    fontSize: '12px',
                    lineHeight: '18.24px',
                    color: '#475666',
                    textAlign: 'center',
                    fontWeight: '400',
                    marginLeft: '40px !important'
                }}>
                    <UsePoints />
                </Tab>
            </Tabs>
        </div>
    );
}

export default RewardsTab;